"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMediaQuery = useMediaQuery;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _canUseDOM = require("../utils/canUseDOM");

var _media = require("../styles/media");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getMatchMedia(breakpoint) {
  if (_canUseDOM.canUseDOM) {
    var media = _media.mediaQuery[breakpoint];
    var matchMedia = window.matchMedia(media);
    return {
      matches: matchMedia.matches,
      removeListener: function removeListener(cb) {
        return matchMedia.removeListener(cb);
      },
      addListener: function addListener(cb) {
        return matchMedia.addListener(cb);
      }
    };
  }

  return {
    matches: false,
    removeListener: function removeListener() {
      return null;
    },
    addListener: function addListener() {
      return null;
    }
  };
} // eslint-disable-next-line no-shadow


function getInitialMatches() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return breakpoints.reduce(function (prev, breakpoint) {
    return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2.default)({}, breakpoint, getMatchMedia(breakpoint).matches));
  }, {});
}

function useMediaQuery() {
  for (var _len = arguments.length, breakpoints = new Array(_len), _key = 0; _key < _len; _key++) {
    breakpoints[_key] = arguments[_key];
  }

  var _useState = (0, _react.useState)(getInitialMatches(breakpoints)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];
  /**
   * Компонент монтируется и по какой-то причине происходит unmount(например закрылось модальное окно), то в этом случае выводится ошибка - о том что необходимо удалить listener.
   * Поэтому определяем, что произошло монтирование и больше не запускаем добавление listener, чтобы исключить ошибку выше.
   * https://github.com/ReactTraining/react-media/issues/139
   */


  var mount = (0, _react.useRef)(false);

  var handleMatch = function handleMatch(breakpoint) {
    return function (e) {
      setMatches(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2.default)({}, breakpoint, e.matches));
      });
    };
  };

  (0, _react.useEffect)(function () {
    if (breakpoints && _canUseDOM.canUseDOM && window.matchMedia && !mount.current) {
      mount.current = true;
      breakpoints.forEach(function (breakpoint) {
        getMatchMedia(breakpoint).addListener(handleMatch(breakpoint));
      });
      return function () {
        breakpoints.forEach(function (breakpoint) {
          getMatchMedia(breakpoint).removeListener(handleMatch(breakpoint));
        });
      };
    }

    return function () {
      return null;
    };
    /**
     * Вызываем useEffect только один раз при перерисовки страницы,
     * чтобы избежать частого обновления matches.
     * В обновление matches будет происходить
     * только при изменении одной из точек отслеживания
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return matches;
}